<template>
	
	
	<div class="row ss-profile">

		<div class="col-md-4 offset-md-4 mb-2 mt-4" v-loading="thinking.save" :element-loading-text="waiting + ' ' + percentage + '%'">
			<div class="form" style="max-width: 300px; margin: auto">

				<div class="alert alert-warning ss-alert" v-if="state.alreadySignedIn">
					<p class="m-0">
						Hi, {{profile.firstname}}. We've made it convenient for you to update your profile and contact information while here.
					</p>
				</div>

				<div class="row">
					<div class="form-group col-md-12 d-block" :class="[{'has-error': errors.has('first name')}]">
						<label>First Name*</label>
						<el-input v-model="profileInternal.firstname" name="first name" data-vv-as="first name" class="w-100" v-validate="'required'" />
						<span v-if="errors.has('first name')">{{errors.first('first name')}}</span>
					</div>

					<div class="form-group col-md-12 d-block" :class="[{'has-error': errors.has('last name')}]">
						<label>Last Name*</label>
						<el-input v-model="profileInternal.lastname" name="last name" class="w-100" v-validate="'required'" />
						<span v-if="errors.has('last name')">{{errors.first('last name')}}</span>
					</div>

				</div>

				<div class="row">
					<div class="form-group col-md-12 d-block" :class="[{'has-error': errors.has('email')}]">
						<label>Email*</label>
						<el-input @focus="emailWarning = true" @blur="emailWarning = false" :disabled="disabled.email" v-model="profileInternal.email" name="email" class="w-100" v-validate="'required|email'" />
						<span v-if="errors.has('email')">{{errors.first('email')}}</span>
						<div class="alert alert-info mt-3" v-if="emailWarning" v-html="$store.state.steps.three.accountDedupeText || 'If you are an existing user please use the same email to create your profile.'"></div>
					</div>

					<div class="form-group col-md-12 d-block" :class="[{'has-error': errors.has('phone')}]">
						<label>Phone*</label>
						<el-input :disabled="$store.state.disableProfileFields" v-model="profileInternal.phone" name="phone" class="w-100" v-validate="'required'" />
						<span v-if="errors.has('phone')">{{errors.first('phone')}}</span>
					</div>
				</div>





				<div v-if="state.signIn && showResetPassword === false">

					<div class="alert alert-info ss-alert">
						<p class="mb-0">
							{{$store.state.steps.three.accountExistsText || 'Looks like you already have an account! Please sign-in by entering your password below.'}}

						</p>

					</div>

					<div class="alert alert-danger ss-alert" v-if="errorsInternal.signIn">
						<p>
							{{errorsInternal.signIn}}
						</p>
						<p class="mb-2">
							<a v-if="errorsInternal.signIn.indexOf('temporarily locked') === -1" style="cursor: pointer" @click="resetPassword">Reset my password</a>
						</p>
						<p class="mb-2">
							<a href="/service">Contact support</a>
						</p>
					</div>


					<div class="form-group d-block" :class="[{'has-error': errors.has('password')}]">
						<el-input type="password" name="password" v-model="password" placeholder="Enter password here..." v-validate="'required'" />

					</div>

				</div>
				<!-- 401 means they entered a correct email but incorrect password -->
				<div v-else-if="showResetPassword" class="mt-2">
					<p class="text-primary">
						If you'd like, we can send a temporary passcode to your phone so you can reset your password, or send a link by email.
					</p>
					
					<div class="form-group d-block">
						<el-input v-model="data.cell" style="width: 290px" placeholder="Enter your phone number">
							<el-button slot="append" :loading="thinking.sendCode" :disabled="data.cell === null || data.cell.length < 14" @click.prevent="generatePasscode">Send</el-button>
						</el-input>
						<div v-if="last2Phone"><small>(###) ###-##{{last2Phone}}</small></div>
					</div>
					<div class="form-group d-block">
						<el-button :disabled="disabled.sendEmail" :loading="thinking.sendEmail" type="link" @click.prevent="generateEmail">Email Me</el-button>
					</div>
					
					
					
					
					<div class="mt-2" v-if="passcode === true">

						<p class="text-primary">
							Two steps to change your password:
							<ol>
								<li>Enter the passcode below.</li>
								<li>Enter a new password.</li>
							</ol>
						</p>

						
						<div class="form-group d-block" :class="[{'has-error': errors.has('recover.passcode')}]">
							<label class="text-primary" for="ss-passcode">Passcode*</label>
							<el-input data-vv-scope="recover" id="ss-passcode" type="number" v-model="data.passcode" name="passcode" data-vv-as="passcode" class="w-100" v-validate="'required'" />
							<span v-if="errors.has('recover.passcode')">{{errors.first('recover.passcode')}}</span>
						</div>

						<div class="form-group d-block" :class="[{'has-error': errors.has('recover.newpassword')}]">
							<label class="text-primary" for="ss-newpassword">Password* <small>7-20 characters - no spaces</small></label>
							<el-input style="width: 215px" show-password data-vv-scope="recover" id="ss-newpassword" type="password" v-model="data.newPassword" name="newpassword" data-vv-as="new password" class="w-100" v-validate="{ required: true, regex:/^\S{7,20}$/ }" />
							<span v-if="errors.has('recover.newpassword')">{{errors.first('recover.newpassword')}}</span>
						</div>
						
						<el-button :loading="thinking.recover" class="w-100 mb-2" @click.prevent="verifyPasscode">Sign In</el-button>
						

					</div>

				</div>

				<div v-if="state.createAccount">

					<div class="alert alert-info ss-alert">
						{{$store.state.steps.three.accountCreateText || 'Create your account by entering a password below.'}}

					</div>

					<div class="alert alert-danger ss-alert" v-if="errorsInternal.createAccount">
						{{errorsInternal.createAccount}}
					</div>

					<div class="form-group d-block" :class="[{'has-error': errors.has('password')}]">
						<el-input type="password" name="password" v-model="password" placeholder="Enter password here..." v-validate="'required'" />
						<span class="help-text">7-20 characters - no spaces</span>
					</div>

				</div>

				<div class="alert alert-danger ss-alert" v-if="errors.any()">
					<p class="mb-0">It looks like you have some errors above. Please check the highlighted fields.</p>
				</div>

				<div class="text-center">
					<div v-if="showResetPassword === false">
						<button v-if="state.alreadySignedIn" @click.prevent="alreadySignedIn" class="btn btn-primary btn-lg btn-block">{{$store.state.steps.three.nextButtonText}}</button>
						<button v-else-if="state.alreadySignedIn === false && state.signIn === false && state.createAccount === false" @click.prevent="accountLookup" class="btn btn-primary btn-lg btn-block">{{$store.state.steps.three.nextButtonText}}</button>
						<button v-else-if="state.signIn === true" @click.prevent="signIn" class="btn btn-primary btn-lg btn-block">SIGN IN</button>
						<button v-else-if="state.createAccount === true" @click.prevent="createAccount" class="btn btn-primary btn-lg btn-block">CREATE ACCOUNT</button>
					</div>
					
					<router-link :to="{ name: 'select-membership' }" tag="a" class="text-primary d-block mt-4">Go Back</router-link>
				</div>


			</div>



		</div>

		

	</div>

	
	
</template>

<script>
	
	import { mapGetters } from "vuex";
	import { rest } from "@/utilities/rest.js";

	export default {
		name: "profile",
		components: {
			
		},
		data() {
			return {
				emailWarning: false,
				profileInternal: {
					// We're storing these in state and null value is fine for everything accept aboutme, so we ensure it's an array here
					aboutme: []
				},
				showResetPassword: false,
				password: null,
				passcode: false,

				disabled: {
					email: false,
					sendCode: false,
					sendEmail: false
				},
				state: {
					alreadySignedIn: false,
					signIn: false,
					createAccount: false
				},

				errorsInternal: {
					signIn: null,
					createAccount: null
				},

				thinking: {
					save: false,
					sendCode: false,
					sendEmail: false,
					recover: false
				},

				waiting: "",
				waitingInterval: null,
				percentage: 0,
				percentageInterval: null,

				data: {
					cell: null,
					passcode: null,
					newPassword: null
				}

												
			}
		},

		created() {
			//if (!this.selectedStudio || !this.selectedPlan) {
			//	this.$router.push({ name: "select-studio" });
			//} else {
			//	this.profileInternal = this.profile;
			//	this.preloadData();
			//}
			if (!this.selectedPlan) {
				this.$router.push({ name: "select-membership" });
			} else {
				this.profileInternal = this.profile;
				this.preloadData();
			}
		},
		mounted() {
			
			
		},
		computed: {
			...mapGetters({
				selectedStudio: "selectedStudio",
				selectedPlan: "selectedPlan",
				locations: "locations",
				plans: "plans",
				profile: "profile"
			})
			
		},

		methods: {

			

			// This method is used when the user is already authenticated
			// We update their profile if anything has changed and then go to the next step
			alreadySignedIn() {
				this.$validator.validateAll().then(valid => {
					if (valid) {
						this.thinking.save = true;
						rest.post("Signup/", "UpdateProfile", "json", JSON.stringify(this.profileInternal)).done(response => {
							this.$router.push({ name: 'payment' });
						}).fail(xhr => {
							if (xhr && xhr.status === 0) {
								alert("We're having difficulty processing your request. Please check your internet connection.")
							}
						}).always(() => {
							this.thinking.save = false;
						});
					}
				});
				
			},

			// This method is used when the user is not signed in, but we want to see if they have an account based on the email provided
			accountLookup() {
				this.$validator.validateAll().then(valid => {
					if (valid) {
						this.thinking.save = true;
						rest.post("Signup/", "AccountLookup", "json", JSON.stringify(this.profileInternal)).done(response => {
							if (response.found) {
								this.state.signIn = true;
								this.disabled.email = true;
							} else {
								this.state.createAccount = true;
							}

						}).fail(xhr => {
							if (xhr && xhr.status === 0) {
								alert("We're having difficulty processing your request. Please check your internet connection.")
							}
						}).always(() => {
							this.thinking.save = false;
						});
					}
				});
			},

			// This method is used when we recognize the email address in accountLookup() method
			signIn() {

				this.$validator.validateAll().then(valid => {
					if (valid) {

						this.thinking.save = true;
						// clone our payload to keep password out of persisted state
						let payload = JSON.parse(JSON.stringify(this.profileInternal));
						payload.remember = true;
						payload.password = this.password;


						rest.post("Login/", "SignIn", "json", JSON.stringify(payload), null, "SunstonevNext/SunstonevNext.Login").done(response => {
							
								// reload the page but in the next step of wizard
							window.location.hash = "#payment";
							window.location.reload();

						}).fail((xhr) => {
							if (xhr && xhr.status === 0) {
								alert("We're having difficulty processing your request. Please check your internet connection.")
							}
							let err = JSON.parse(xhr.responseText);
							this.errorsInternal.signIn = err.errorMessage;
							this.last2Phone = err.last2Phone
							this.thinking.save = false;
						}).always(() => {
							
						});
					}
				});
			},

			// This method is used when we recognize the email address in accountLookup() method
			createAccount() {

				this.$validator.validateAll().then(valid => {
					if (valid) {

						this.thinking.save = true;



						
						let vm = this;
						vm.percentageInterval = setInterval(() => {
							if (vm.percentage < 100) {
								++vm.percentage;
							} else {
								clearInterval(vm.percentageInterval);
								vm.waiting = vm.$store.state.steps.three.waiting || "Just a few more seconds!";
							}
						}, 200);




						// clone our payload to keep password out of persisted state
						let payload = JSON.parse(JSON.stringify(this.profileInternal));
						payload.password = this.password;
						rest.post("Signup/", "CreateAccount", "json", JSON.stringify(payload)).done(response => {
							if (response.success) {
								vm.waiting = "Success!";
								// reload the page but in the next step of wizard
								window.location.hash = "#payment";
								window.location.reload();
							} 

						}).fail((xhr) => {
							if (xhr && xhr.status === 0) {
								alert("We're having difficulty processing your request. Please check your internet connection.")
							}
							this.errorsInternal.createAccount = JSON.parse(xhr.responseText);
							this.thinking.save = false;
						}).always(() => {
							clearInterval(vm.percentageInterval);
						});
					}
				});
			},


			

			// We check if the user is already signed in and preload the form with their information
			preloadData() {
				this.thinking.save = true;
				rest.post("Signup/", "PreloadData", "json", JSON.stringify(this.profileInternal)).done(response => {

					// If userId is greater than 0 then they are already signed in
					if (response.userId > 0) {
						this.profileInternal = response;

						// Let them know we've detected a user account and any changes will update their profile
						this.state.alreadySignedIn = true;
						// Do not let them change their email (username)
						this.disabled.email = true;

					} else {
						// If the user was previously signed in, but has come back to this page, be sure to reset the userId in state
						this.profileInternal.userId = null;

					}
				}).always(() => {
					this.thinking.save = false;
				});

			},

			

			resetPassword() {
				this.showResetPassword = true;
				//this.$validator.validateAll().then(result => {
				
				//	if (result) {
				//		this.thinking.save = true;
				//		rest.post("Signup/", "ResetPassword", "json", JSON.stringify(this.profileInternal)).done(response => {
				//			this.signInError = null;
				//			this.$message({
				//				message: "Please check your email for instructions. If you don't receive it soon, please contact us.",
				//				center: true
				//			});						
				//		}).always(() => {
				//			this.thinking.save = false;
				//		});
						
				//	}
				//})
			},

			generatePasscode() {
				this.thinking.sendCode = true;
				rest.post("Login/", "GeneratePasscode", "json", JSON.stringify({ cell: this.data.cell, email: this.profileInternal.email }), null, "SunstonevNext/SunstonevNext.Login").done(response => {
					this.passcode = true;
				}).fail((xhr) => {
					console.log(xhr);
					this.$alert(JSON.parse(xhr.responseText));
				}).always(() => {
					this.thinking.sendCode = false;
					this.disabled.sendCode = true;
					setTimeout(() => {
						this.disabled.sendCode = false;
					}, 10000);
				})
			},

			generateEmail() {
				this.thinking.sendEmail = true;
				rest.post("Login/", "GenerateEmail", "json", JSON.stringify({ email: this.profileInternal.email }), null, "SunstonevNext/SunstonevNext.Login").done(response => {
					this.$alert("Instructions to reset your password were sent via email. It may take a few minutes for it to arrive. Be sure to check your spam folder.");
					
				}).fail((xhr) => {
					this.$alert(JSON.parse(xhr.responseText));
					
				}).always(() => {
					this.thinking.sendEmail = false;
				})
			},

			verifyPasscode() {
				this.$validator.validateAll("recover").then(valid => {
					if (valid) {
						this.thinking.recover = true;
						this.data.email = this.profileInternal.email;
						rest.post("Login/", "VerifyPasscode", "json", JSON.stringify(this.data), null, "SunstonevNext/SunstonevNext.Login").done(response => {

							window.location.hash = "#payment";
							window.location.reload();							
						}).fail(xhr => {
							
							this.$alert(JSON.parse(xhr.responseText));
							this.thinking.recover = false;
						}).always(() => {
							
						});
					}
				});
			}
			
		},

		watch: {
			'profileInternal.phone': function (val) {
				if (val && val.length) {
					var x = val.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
					this.profileInternal.phone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
				}
				
			},
			'data.cell': function (val) {
				if (val && val.length) {
					var x = val.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
					this.data.cell = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
				}				
			},
			'profileInternal.email': function (val) {
				if (this.state.createAccount) {
					this.state.createAccount = false;
				}
			},
			profileInternal: {
				handler(val) {
					this.$store.commit("setProfile", val);
				},
				deep: true
			}
		}
	}
</script>

<style>
	.acc-progress {
		position: absolute;
		z-index: 2001;
		margin: 0;
		top: 0;
		right: 0;
		left: 0;
		bottom: 0;
	}
</style>

